import React, { useEffect } from "react";

import { Grid, Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { AuthenticationContext, FlashContext } from "../../../../Context";
import { getHeaders } from "../../../../utils/HeaderHelper";
import ActionRow from "../../../../action_queue/global_action_queue/ActionRow";
import moment from "moment";
import MonthHeader from "../../../../action_queue/global_action_queue/MonthHeader";

interface props {
  refreshActionQueue?: string;
  reloadPrograms?: (value: boolean) => void;
}

interface ActionQueueItem {
  due_date: string;
  action_data: any[];
}

const PatientActionQueue: React.FC<props> = ({
  refreshActionQueue,
  reloadPrograms,
}) => {
  let { id: patientId } = useParams();
  let lastDisplayedMonth = "";
  const authenticationSetting = React.useContext(AuthenticationContext);
  const [actionQueues, setActionQueues] = React.useState<any>([]);
  const [providers, setProviders] = React.useState<any>([]);
  useEffect(() => {
    fetchProviders();
    // Reset the state and fetch new data when filter changes
    setActionQueues([]);

    fetchActionQueues();
  }, [refreshActionQueue]);

  const fetchActionQueues = async () => {
    const queryParams = new URLSearchParams({
      patient_id: patientId,
    });

    const response = await fetch(
      `/data_fetching/get_patient_actions?${queryParams}`,
      {
        method: "GET",
        headers: getHeaders(authenticationSetting.csrfToken),
      }
    );

    if (response.status === 404) {
      window.location.href = "/not-found";
      return;
    }
    const result = await response.json();
    if (result.success == false) {
      alert(result.error);
    } else {
      // Replace existing data for first page
      setActionQueues(result.resource?.data || []);
    }
  };
  const fetchProviders = async () => {
    const response = await fetch(`/data_fetching/core_teams`, {
      method: "GET",
      headers: getHeaders(authenticationSetting.csrfToken),
    });
    if (response.status === 404) {
      window.location.href = "/not-found";
      return;
    }
    const result = await response.json();
    if (result.success == false) {
      alert(result.error);
    } else {
      const formattedProviders = result.resource.providers.map((provider) => ({
        id: provider.id,
        name: `${provider.last_name}, ${provider.first_name}`,
      }));
      setProviders(formattedProviders);
    }
  };
  return (
    <Grid container className="panel-container" borderRadius={"4px"}>
      <Grid item xs={12} className="patient-edit-container patient-edit-form" sx={{ overflow: "unset" }}>
        <Grid container>
          <Grid
            className="patient-edit-header"
            container
            justifyContent="space-between"
          >
            <Grid item xs={3} display={"flex"} alignItems={"center"}>
              <p className="secondary-label" style={{ marginLeft: "0px" }}>
                Patient's Action Queue
              </p>
            </Grid>
          </Grid>

          <Grid container className="p-4">
            <Grid item xs={12}>
              <Box width={"100%"}>
                <Box
                  sx={{
                    display: "flex",
                    paddingBottom: "10px",
                    py: 2,
                    width: "100%",
                  }}
                  className="box-header"
                >
                  <Box
                    sx={{ flexBasis: "120px", textAlign: "left" }}
                    className="action-table-header"
                  >
                    Due Date
                  </Box>
                  <Box
                    sx={{ flexBasis: "10%", textAlign: "left", ml: 2 }}
                    className="action-table-header"
                  >
                    Status
                  </Box>
                  <Box
                    sx={{ flexBasis: "20%", textAlign: "left" }}
                    className="action-table-header"
                  >
                    Action Title
                  </Box>
                  <Box
                    sx={{ flexBasis: "20%", textAlign: "left" }}
                    className="action-table-header"
                  >
                    Subtext
                  </Box>
                  <Box
                    sx={{ flexBasis: "20%", textAlign: "left" }}
                    className="action-table-header"
                  >
                    Provider
                  </Box>
                  <Box
                    sx={{ flexBasis: "20%", textAlign: "center" }}
                    className="action-table-header"
                  ></Box>
                </Box>

                <Box
                  sx={{
                    overflowY: "auto",
                    height: "calc(100vh - 400px)",
                    position: "relative",
                    "& .sticky-month-header": {
                      position: "sticky",
                      top: 0,
                      zIndex: 1,
                      backgroundColor: "#F5F5F5",
                    },
                  }}
                  className="action-queue-layout"
                >
                  {actionQueues.length > 0 ? (
                    Object.entries(
                      actionQueues.reduce((acc, aq) => {
                        const month = moment(aq.due_date)
                          .format("MMMM - YYYY")
                          .toUpperCase();
                        if (!acc[month]) acc[month] = [];
                        acc[month].push(aq);
                        return acc;
                      }, {})
                    ).map(([month, items]: [string, ActionQueueItem[]]) => {
                      const showMonth = month !== lastDisplayedMonth;

                      if (showMonth) {
                        lastDisplayedMonth = month;
                      }
                      return (
                        <div key={month}>
                          <MonthHeader month={month} />
                          {items.map((aq, index) => (
                            <ActionRow
                              key={index}
                              aq={aq}
                              providers={providers}
                              patientOnly={true}
                              showMonth={showMonth}
                              reloadData={fetchActionQueues}
                              reloadPrograms={reloadPrograms}
                            />
                          ))}
                        </div>
                      );
                    })
                  ) : (
                    <Box sx={{ textAlign: "center", py: 2 }}>
                      No actions found for the selected date range.
                    </Box>
                  )}
               </Box>
              </Box>
              {/* {hasMoreData && (
                  <Stack
                    width={"100%"}
                    justifyContent={"center"}
                    display={"flex"}
                    alignItems={"center"}
                    my={2}
                  >
                    <Link
                      sx={{ textDecoration: "underline" }}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLoadMore();
                      }}
                    >
                      Load More
                    </Link>
                  </Stack>
                )} */}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default PatientActionQueue;
